import { useEffect, useState } from "react";

import purify from "dompurify";
import { useTranslation } from "pro-features/components/WithTranslation";

import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { Button, Modal } from "@similarweb/ui-components";
import { Flex, Text } from "@similarweb/ui-components/foundations";

import {
    DUNNINGS_RESTART_TRIAL_EVENT_SUB_SUB_NAME,
    DUNNINGS_SITEWIDE_BANNER_CTA_LOCATION,
    RESTART_TRIAL_DUNNINGS_EVENT_NAME,
} from "app/components/Dunnings/dunningsConstants";
import { StyledRestartTrialDunningsSitewideBanner } from "app/components/Dunnings/RestartTrialDunningsSitewideBanner/RestartTrialDunningsSitewideBannerStyled";
import { useDunnings } from "app/components/hooks/useDunnings";
import { usePageTopBannerStripReveal } from "app/components/PageTopBanner/bannerRevealContext";
import { afterTrialBannerModalStyles } from "app/common/after-trial/afterTrialBannerModalStyles";
import { AfterTrialPopupContainer } from "app/components/React/AfterTrialPopup/AfterTrialPopupContainer";
import { allTrackers } from "app/services/track/track";
import { isSI } from "app/UtilitiesAndConstants/UtilityFunctions/trialUsersUtils";

export const RestartTrialDunningsSitewideBanner = () => {
    const translate = useTranslation();
    const { onDunningsButtonClicked } = useDunnings();
    const [isStartTrialModalOpen, setIsStartTrialModalOpen] = useState(false);
    const stripProps = usePageTopBannerStripReveal();

    useEffect(() => {
        allTrackers.dispatchTrackEvent(
            "banner",
            "show",
            `${RESTART_TRIAL_DUNNINGS_EVENT_NAME}/${DUNNINGS_SITEWIDE_BANNER_CTA_LOCATION}`,
        );
    }, []);

    const onClick = () => {
        onDunningsButtonClicked(
            `${RESTART_TRIAL_DUNNINGS_EVENT_NAME}/${DUNNINGS_SITEWIDE_BANNER_CTA_LOCATION}/${DUNNINGS_RESTART_TRIAL_EVENT_SUB_SUB_NAME}`,
        );
        setIsStartTrialModalOpen(true);
    };

    return (
        <>
            <StyledRestartTrialDunningsSitewideBanner
                {...stripProps}
                data-automation="restart-trial-dunnings-sitewide-banner"
            >
                <Flex
                    gap="8px"
                    alignItems="center"
                >
                    <SWReactIcons
                        iconName="gift"
                        iconColor={colorsPalettes.carbon[0]}
                        size="sm"
                    />

                    <Text
                        fontVariant="subtitle2"
                        color={colorsPalettes.carbon[0]}
                        dangerouslySetInnerHTML={{
                            // eslint-disable-next-line @typescript-eslint/naming-convention
                            __html: purify.sanitize(translate("dunnings.restartTrial.banner.text")),
                        }}
                    />
                </Flex>

                <Button
                    onClick={onClick}
                    type="inverted"
                >
                    {translate("dunnings.restartTrial.banner.button")}
                </Button>
            </StyledRestartTrialDunningsSitewideBanner>

            <Modal
                isOpen={isStartTrialModalOpen}
                onRequestClose={() => setIsStartTrialModalOpen(false)}
                customStyles={afterTrialBannerModalStyles}
                shouldCloseOnOverlayClick={true}
            >
                <AfterTrialPopupContainer
                    setIsOpen={setIsStartTrialModalOpen}
                    isSI={isSI()}
                />
            </Modal>
        </>
    );
};
